// apiAuth.js
// notify-server verifies the caller server-side on admin and sender routes
// (project writes, the full GET /api/projects/:id, /api/admin/acl,
// /api/notify/sync-status, /api/notify/teams) from a Microsoft Graph bearer
// token -- the signed-in user's own MSAL token, the same one ConsentForm and
// Directory Sync already send. makeAuthFetch returns a fetch() that attaches
// it. If no token can be acquired it rejects rather than sending the request
// unauthenticated.
import { loginRequest } from "./authConfig";

export function makeAuthFetch(instance, account) {
  return async function authFetch(url, options) {
    const tokenResp = await instance.acquireTokenSilent({ ...loginRequest, account: account });
    const opts = options || {};
    return fetch(url, { ...opts, headers: { ...opts.headers, Authorization: "Bearer " + tokenResp.accessToken } });
  };
}
